import { Drawer, Button, Badge } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Link } from "react-router-dom";
import { useContext, useEffect } from "react";
import { UserContext } from "../context/UserContext";
import { useNavigate, useLocation } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert"; // Import confirm alert for logout confirmation
import "react-confirm-alert/src/react-confirm-alert.css"; // Import CSS for confirm alert

const MyDrawer = ({ openDrawer, setOpenDrawer }) => {
  const location = useLocation(); // Get the current route
  const navigate = useNavigate(); // Hook for navigation
  const { userState, dispatch } = useContext(UserContext); // Access user state and dispatch function

  // Close the drawer when navigating to a different page
  useEffect(() => {
    setOpenDrawer(false);
  }, [navigate]);

  // Handle user logout with confirmation
  const handleLogout = () => {
    setOpenDrawer(false);
    confirmAlert({
      title: "Log out confirmation",
      message: "Do you really want to log out?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            const newCurrentUser = {
              username: "",
              fname: "",
              lname: "",
              email: "",
              password: "",
              cart: {
                products: [],
                amount: 0,
                total: 0,
              },
              purchasedProducts: [],
            };
            localStorage.setItem("currentUser", JSON.stringify(newCurrentUser));
            dispatch({
              type: "logout",
            });
            navigate("/login"); // Redirect to login page after logout
          },
        },
        {
          label: "No", // Cancel logout
        },
      ],
    });
  };

  return (
    <>
      <Drawer
        open={openDrawer}
        anchor="right"
        onClose={() => setOpenDrawer(false)}
        PaperProps={{
          sx: {
            width: "150px",
            height: "100vh",
            display: "flex",
            alignItems: "center",
          },
        }}
      >
        {/* Home button */}
        <Link to="/" style={{ width: "100%" }}>
          <Button
            color="primary"
            sx={{
              width: "100%",
              backgroundColor:
                location.pathname === "/" ? "#3A3F4B" : "transparent",
            }}
          >
            Home
          </Button>
        </Link>

        {/* Profile button (only visible if the user is logged in) */}
        {userState.username && (
          <Link
            to="/profile"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "5px 10px",
              borderRadius: "5px",
              width: "88%",
              backgroundColor:
                location.pathname === "/profile" ? "#3A3F4B" : "transparent",
            }}
          >
            <AccountCircleIcon
              color="primary"
              fontSize="medium"
              sx={{
                cursor: "pointer",
              }}
            />
          </Link>
        )}

        {/* Cart button (only visible if the user is logged in) */}
        {userState.username && (
          <Link to="/cart" style={{ width: "100%" }}>
            <Button
              sx={{
                color: "primary",
                position: "relative",
                width: "100%",
                backgroundColor:
                  location.pathname === "/cart" ? "#3A3F4B" : "transparent",
              }}
            >
              <Badge
                badgeContent={userState.cart.amount}
                sx={{
                  "& .MuiBadge-badge": {
                    backgroundColor: "red",
                    color: "white",
                    top: -15,
                    right: -65,
                  },
                }}
              />
              My Cart
            </Button>
          </Link>
        )}

        {/* Login button (only visible if the user is not logged in) */}
        {!userState.username && (
          <Link to="/login" style={{ width: "100%" }}>
            <Button
              color="primary"
              sx={{
                width: "100%",
                backgroundColor:
                  location.pathname === "/login" ? "#3A3F4B" : "transparent",
              }}
            >
              Log In
            </Button>
          </Link>
        )}

        {/* Signup button (only visible if the user is not logged in) */}
        {!userState.username && (
          <Link to="/signup" style={{ width: "100%" }}>
            <Button
              color="primary"
              sx={{
                width: "100%",
                backgroundColor:
                  location.pathname === "/signup" ? "#3A3F4B" : "transparent",
              }}
            >
              Sign Up
            </Button>
          </Link>
        )}

        {/* Logout button (only visible if the user is logged in) */}
        {userState.username && (
          <Button color="primary" onClick={handleLogout} sx={{ width: "100%" }}>
            Log Out
          </Button>
        )}
      </Drawer>
    </>
  );
};

export default MyDrawer;
